export function setSessionEntry(
  key: string,
  value: number | string | Date | undefined
) {
  const sessionObject =
    JSON.parse(sessionStorage.getItem("quoteCalculation") as string) || {};
  sessionObject[key] = value;
  sessionStorage.setItem("quoteCalculation", JSON.stringify(sessionObject));
}

export function getSessionObject(): {
  petTypeId: number;
  breedId: number;
  birthday: string;
  productGroupId: number;
} {
  return JSON.parse(sessionStorage.getItem("quoteCalculation") as string);
}
